import { render, staticRenderFns } from "./rpterctstdexam.vue?vue&type=template&id=23df5c06&"
import script from "./rpterctstdexam.vue?vue&type=script&lang=js&"
export * from "./rpterctstdexam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports